/**
 * 新闻服务
 */

import { httpClient } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export const newsService = {
  async getList(params: any) {
    return httpClient.get(API_ENDPOINTS.NEWS.LIST, { 
      params
    });
  },
  
  async getById(id: number) {
    return httpClient.get(`${API_ENDPOINTS.NEWS.DETAIL}/${id}`);
  },
  
  async create(data: any) {
    return httpClient.post(API_ENDPOINTS.NEWS.CREATE, data);
  },
  
  async update(data: any) {
    return httpClient.put(API_ENDPOINTS.NEWS.UPDATE, data);
  },
  
  async delete(id: number) {
    return httpClient.delete(`${API_ENDPOINTS.NEWS.DELETE}/${id}`);
  },
  
  async batchDelete(ids: number[]) {
    return httpClient.delete(API_ENDPOINTS.NEWS.BATCH_DELETE, { data: ids });
  }
};